import Icon from '@ant-design/icons';

import { routing, MenuDisplayConditions } from '@/modules/routing';

//// Specific to this App

import LicenceAreaDashboard from '@/pages/LicenceAreaDashboard';
import DistrictDashboard from '@/pages/DistrictDashboard';
import EventLibrary from '@/pages/EventLibrary';
import EventReport from '@/pages/EventReport';
import LicenceAreaImpact from '@/pages/LicenceAreaImpact';
import LicenceAreaImpactComparison from '@/pages/LicenceAreaImpactComparison';
import LicenceAreaImpactSimulator from '@/pages/LicenceAreaImpactSimulator';
import Settings from '@/pages/Settings';
import PlatformSettings from '@/pages/PlatformSettings';
import UserManagement from '@/pages/UserManagement';
import UserPreferences from '@/pages/UserPreferences';
import ForecastQuality from '@/pages/ForecastQuality';

import HomeIcon from '@/assets/pictos/home.svg?react';
import ControlIcon from '@/assets/pictos/control.svg?react';
import ForecastQualityIcon from '@/assets/pictos/forecastQuality.svg?react';
import LibraryIcon from '@/assets/pictos/library.svg?react';
import SettingIcon from '@/assets/pictos/settings.svg?react';

// To generate Pages
const routesList = [
  {
    element: <LicenceAreaDashboard />,
    path: '/control-room',
    title: 'controlRoomDashboard',
    icon: <Icon component={HomeIcon} />,
    hideInMenu: false,
    hideHeader: false,
  },
  {
    element: <DistrictDashboard />,
    path: '/licence-area/district/:districtId',
    title: 'districtDashboard',
    hideInMenu: true,
    hideHeader: true,
  },
  {
    element: <LicenceAreaDashboard />,
    path: '/licence-area',
    title: 'licenceAreaDashboard',
    icon: <Icon component={ControlIcon} />,
    hideInMenu: false,
    hideHeader: true,
  },
  {
    element: <div>&#8203;</div>,
    path: '/event-library/:weatherEventId',
    title: 'weatherEvent',
    hideInMenu: true,
    hideHeader: false,
    routes: [
      {
        isPage: true,
        element: <LicenceAreaImpactComparison />,
        path: 'licence-area-impact/:licenceAreaId/comparison',
        title: 'Comparison with Current Forecast',
      },
      {
        isTab: true,
        element: <EventReport />,
        path: 'event-report',
        title: 'Event Report',
      },
      {
        isTab: true,
        element: <LicenceAreaImpact />,
        path: 'licence-area-impact',
        title: 'Licence Area Impact',
      },
      {
        isTab: true,
        element: <LicenceAreaImpactSimulator />,
        path: 'weather-event-simulator',
        title: 'Weather Event Simulator',
      },
    ],
  },
  {
    element: <EventLibrary />,
    path: '/event-library',
    title: 'eventLibrary',
    icon: <Icon component={LibraryIcon} />,
    hideInMenu: false,
    hideHeader: false,
  },
  {
    element: <ForecastQuality />,
    path: '/forecast-quality',
    title: 'Forecast Quality',
    icon: <Icon component={ForecastQualityIcon} />,
    hideInMenu: false,
    hideHeader: false,
  },
  {
    element: <Settings />,
    path: '/settings',
    title: 'settings',
    icon: <Icon component={SettingIcon} />,
    routes: [
      {
        isTab: true,
        element: <PlatformSettings />,
        path: 'platform-settings',
        title: 'Platform Settings',
      },
      {
        isTab: true,
        element: <UserManagement />,
        path: 'users-management',
        title: 'User Management',
      },
    ],
  },
  {
    element: <UserPreferences />,
    path: '/user-preferences',
    title: 'userPreferences',
    hideInMenu: true,
  },
];

//// Necessary for the App - Not to be removed!
export default (menuConditions: MenuDisplayConditions[]) => {
  const mailUrlIsControlRoom = menuConditions[0].display;

  const mainUrl = mailUrlIsControlRoom
    ? routesList[0].path
    : routesList[2].path;

  return routing(routesList, mainUrl, menuConditions);
};
